import { AdobeAnalyticsConst } from '@/hooks/AdobeAnalyticsHooks/adobeAnalyticsConstants/adobeAnalyticsConstants';
import NavigationTabList, {
  type NavigationTabListProps,
} from '@/storybook/components/NavigationTabList/NavigationTabList';
import { useChannelConfigData } from './utils/useChannelConfigData';
import { UsePartnerScoreFilterReturn } from '../PartnerScoreFilter';

export const testIds = {
  tabSwitcherContainer: 'ces-tab-switcher-container',
  tabSwitcherLink: (label: string) => `ces-tab-switcher-link-${label}`,
  tabSwitcherLabel: (label: string) => `ces-tab-switcher-label-${label}`,
  tabSwitcherCoverage: (label: string) => `ces-tab-switcher-coverage-${label}`,
  tabSwitcherValue: (label: string) => `ces-tab-switcher-value-${label}`,
  tabSwitcherArrowDirection: (label: string) => `ces-tab-switcher-arrow-direction-${label}`,
  tabSwitcherCaption: (label: string) => `ces-tab-switcher-caption-${label}`,
};

const NAVIGATION_TAB_ADOBE_ANALYTICS_CONFIG: NavigationTabListProps['adobeTrackingAnalytics'] = {
  trackingPosition: AdobeAnalyticsConst.POSITIONS.NAVIGATION_TABS,
  trackingPrefixName: AdobeAnalyticsConst.LINKCLICK_NAMES.PARTNER_SCORE_NAVIGATION_TABS,
};

interface TabSwitcherProps extends Pick<UsePartnerScoreFilterReturn, 'year' | 'quarter'> {}

export default function TabSwitcher({ year, quarter }: TabSwitcherProps) {
  const navigationTabList = useChannelConfigData({ year, quarter });

  return (
    <NavigationTabList
      tabs={navigationTabList}
      adobeTrackingAnalytics={NAVIGATION_TAB_ADOBE_ANALYTICS_CONFIG}
      data-testid={testIds.tabSwitcherContainer}
    />
  );
}
